import React, { Component } from 'react';
import IgniteDataTable from '../../../../common/datatable';

class SellItObjectiveList extends Component {
  constructor(props) {
    super(props);

    this.columns = [
      {
        prop: 'id',
        title: 'ID'
      },
      {
        prop: 'name',
        title: 'Name'
      },
      {
        prop: 'start_date',
        title: 'Start Date'
      },
      {
        prop: 'end_date',
        title: 'End Date'
      },
      {
        prop: 'points_awarded',
        title: 'Total points awaded from scans'
      }
    ];
  }
  render() {
    const { sellItObjectives } = this.props;

    return (
      <IgniteDataTable
        columns={this.columns}
        data={sellItObjectives}
        hasAttributes={false}
      />
    );
  }
}

export default SellItObjectiveList;



// WEBPACK FOOTER //
// ./src/components/admin/scans/scans/view/sell-it-objective-list.jsx